module.exports = __webpack_public_path__ + "img/product29-shanghu.881ec07d.svg";